import React from 'react';
import {
  Select,
  TreeSelect,
  TreeSelectProps,
  SelectProps,
  Flex,
  Row,
  Checkbox,
  Pagination,
  Col,
  Button,
} from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {
  FilterCommonInnerProps,
  FilterCommonProps,
  FilterTypes,
} from '@/component/FilterCommon/Filter';
import { axiosHttp } from '@/utils/http';
import {
  serviceSuppliers,
} from '@/component/Filter/services/common/filter';
import { isError } from '@/component/common/error';
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import { SelectModalPc } from '../Common/SelectModalPc';
import { FilterPc } from '../FilterPc';
import {
  DhbFilterForm,
  DhbFooterProps,
} from '@/component/PageComponent/PageComponent';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { useSelectModalList } from '../hooks/useSelectModalList';
import { LabeledValue } from 'antd/es/select';
import { useRequest } from 'ahooks';

type FilterParams = Partial<{
  kw: string;
  page: number;
  pageSize: number;
  base_client_id: string;
}>;

const initParams: FilterParams = {
  page: 1,
  pageSize: 10,
};

const columns = [
  {
    width: 50,
    dataIndex: 'sequence',
    render: (text:string, record:any, index:number) => {
      return index + 1;
    },
  },
    {
    width: '20%',
    title: '供应商编号',
    dataIndex: 'client_num',
  },
  {
    title: '供应商名称',
    dataIndex: 'client_name',
  },
  {
    width: '20%',
    title: '联系人',
    dataIndex: 'contact',
  },
  {
    width: '20%',
    title: '联系电话',
    dataIndex: 'phone',
  },
];

const DhbFooter = (
  props: DhbFooterProps & { onCancel(): void; onOk(): void },
) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;

  return (
    <div style={{ padding: '10px' }}>
      <Row>
        <Col span={14}>
          <Pagination
            style={{ textAlign: 'left' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            onShowSizeChange={(current, pageSize) =>
              onChange({ page: 1, pageSize })
            }
            showQuickJumper={false}
          />
        </Col>
        <Col span={10}>
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => props.onCancel()}
              style={{ margin: '0 10px' }}
            >
              取消
            </Button>
            <Button type="primary" onClick={() => props.onOk()}>
              确定
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const listKey = 'base_client_id';

interface SupplierItem {
  address: string;
  base_client_id: string;
  city_id: string;
  client_id: string;
  client_name: string;
  client_num: string;
  contact: string;
  email: string;
  mobile: string;
  phone: string;
  remark: string;
}

interface SupplierListModalProps {
  onChangeValues(values:string[],options: LabeledValue[],dataSource:SupplierItem[]):void;
  onClose(): void;  
  value: any;
}

const SupplierListModal = (props: SupplierListModalProps) => {
  const [suppliers, setSuppliers] = React.useState<SupplierItem[]>([]);
  const [count, setCount] = React.useState(0);
  
  const getSuppliers = async (params: FilterParams) => {
    let res = await serviceSuppliers(params);
    if (isError(res.data)) {
      return;
    }
    let data = res.data?.data || {};
    setSuppliers(data.list || []);
    setCount(data.count || 0);
  };
  
  let { setParams, setPageInfo, loading, pageInfo, params } = useGetData({
    getData: getSuppliers,
    defaultParams: initParams,
  });
  
  const { selectedRowKeys, isAllSelect, toggleSelectRowKeys, setSelectedRowKeys } = useSelectRow(suppliers, listKey);
  
  React.useEffect(() => {
    getSuppliers({ ...params, ...pageInfo });
  }, []);
  
  return (
    <Flex vertical style={{ height: '100%',padding:0}}>
      <h2 style={{ paddingLeft: '16px',margin:'16px 0 0 0' }}>供应商选择</h2>
      <DhbFilterForm
        defaultParams={initParams}
        loading={loading}
        onSearch={(params) => setParams(params)}
        filterProps={{
          filters: [
            {
              type: FilterTypes.Input,
              dataIndex: 'kw',
              flex: 2,
              placeholder: '名称/手机号/联系人/编号',
            },
          ],
        }}
      />
      <TableResize
        style={{ flex: 1, padding: '0 20px 16px 16px' }}
        rowKey={listKey}
        pagination={false}
        columns={columns}
        dataSource={suppliers}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: (keys) => {
            setSelectedRowKeys(keys as any);
          },
        }}
        size="middle"
      />
      <DhbFooter
        selectedRowKeys={selectedRowKeys}
        dataSource={suppliers}
        isAllSelect={isAllSelect}
        toggleSelectRowKeys={toggleSelectRowKeys}
        onChange={(pageInfo) => {
          setPageInfo(pageInfo);
        }}
        total={count}
        pageInfo={pageInfo}
        onCancel={() => {
          props.onClose();
        }}
        onOk={() => {
          props.onClose();
          let selectedRow: SupplierItem[] = [];
          suppliers.forEach((item) => {
            if (selectedRowKeys.includes(item[listKey])) {
              selectedRow.push(item);
            }
          });
          let options = selectedRow.map(item => ({label:item.client_name,value:item.base_client_id}))
          props.onChangeValues &&
            props.onChangeValues(selectedRowKeys, options, selectedRow);
        }}
      />
    </Flex>
  );
};

export interface FilterSupplierPcProps extends SelectProps {

}

export const FilterSupplierPc = (props: FilterSupplierPcProps) => {
  const { list:suppliers, setList:setSuppliers, prependList } = useSelectModalList<SupplierItem>({listKey:'base_client_id',value:props.value,componentKey:'filterSupplierPc'})
  const [isFirstFoucus,setIsFirstFoucus] = React.useState<boolean>(true);
  const {  ...reset } = props;
  
  const {run:getSuppliers,loading} = useRequest(async (params?:{kw?:string}) => {
    const {kw} = params || {}
    let res = await serviceSuppliers({
      page: 0,
      pageSize: 10,
      kw:kw
    });
    if (isError(res.data)) {
      return;
    }
    let data = res.data?.data || {};
    setSuppliers(data.list || []);

  },{manual:true});
  
  let onChange: Required<SelectProps>['onChange'] = (value, option) => {
    props.onChange && props.onChange(value, option)
  };
  
  const focus = ()=>{
    if(isFirstFoucus){
      if(!suppliers.length){
        getSuppliers()
      }
      setIsFirstFoucus(false)
    }
  }
  
  return (
    <div>
      <SelectModalPc
        style={{ width: '100%'}}
        mode="multiple"
        onFocus={focus}
        loading={loading}
        MoreComponent={({ onClose }) => (
          <SupplierListModal
            value={props.value}
            onClose={onClose}
            onChangeValues={(values,option,sources)=>{
              prependList(sources)
              onChange(values,option)
            }}
          />
        )}
        placeholder={'请选择供应商'}
        onSearch={(kw)=>{
          getSuppliers({kw})
        }}
        {...reset}
        onChange={(value, option) => {
          onChange && onChange(value, option);
        }}
        options={suppliers.map(supplier=>{
          return {
            label: supplier.client_name,
            value: supplier.base_client_id
          }
        })}
      />
    </div>
  );
};